/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export interface LabelProps {
    label: string | JSX.Element;
    className?: string;
    optional?: boolean;
    optionalFlagClassName?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        optional: {
            color: theme.palette.grey[500],
            marginLeft: theme.spacing(1),
        },
    })
);

export const Label = (props: LabelProps) => {
    const classes = useStyles();
    const { optional, label, className, optionalFlagClassName } = props;

    return (
        <>
            <Typography variant='body1' className={className}>
                {label}
            </Typography>
            {
                optional && (<Typography variant='body1' className={optionalFlagClassName || classes.optional} >
                    <FormattedMessage id="components.shared.Label.optional" defaultMessage="(Optional)" />
                </Typography>)
            }
        </>
    );
}

export default Label;
